import {
  Action,
  ActionType,
  IPatientRegistrationResponse,
} from "models/setting/patientRegistration";
import createReducer from "redux/createReducer";

export interface PatientRegistrationReducerType {
  loading: boolean;
  error?: string;
  patientRegistrationResponse?: IPatientRegistrationResponse;
}

const defaultState: PatientRegistrationReducerType = {
  loading: false,
  error: undefined,
  patientRegistrationResponse: undefined,
};

export const patientRegistrationReducer =
  createReducer<PatientRegistrationReducerType>(defaultState, {
    [ActionType.PATIENT_REGISTRATION](state: PatientRegistrationReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.PATIENT_REGISTRATION_ERROR](
      state: PatientRegistrationReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.PATIENT_REGISTRATION_SUCCESS](
      state: PatientRegistrationReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        patientRegistrationResponse: action.payload,
      };
    },

    [ActionType.PATIENT_REGISTRATION_RESET](
      state: PatientRegistrationReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        patientRegistrationResponse: undefined,
      };
    },
  });
